module.exports = __webpack_public_path__ + "img/DTYLX_Jap.495ab275.png";